import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppView, AssetsStore, UserStore, ViewStore } from '@coach-bot/data-access/shared';
import { AuthState } from '@coach-bot/features/auth';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, combineLatest, map, mergeMap } from 'rxjs';

@Component({
  selector: 'da-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyComponent {
  readonly assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;
  readonly extensionIcon$: BehaviorSubject<string> = this.viewStore.extensionIcon$;
  readonly extensionNameFriendly$: BehaviorSubject<string> = this.viewStore.extensionNameFriendly$;
  readonly isSignedId$: BehaviorSubject<boolean> = this.userStore.isSignedIn$;

  readonly description$: Observable<string> = this.extensionNameFriendly$.pipe(mergeMap((name: string) => {
    return this.translateService.stream('dashboard.empty.labels.description', { name });
  }));
  readonly icon$: Observable<string> = combineLatest([this.assetsPath$, this.extensionIcon$]).pipe(
    map(([assetsPath, extensionIcon]: [string, string]) => `${assetsPath}/${extensionIcon}`),
  );

  constructor(
    private assetsStore: AssetsStore,
    private authState: AuthState,
    private translateService: TranslateService,
    private userStore: UserStore,
    private viewStore: ViewStore,
  ) {}

  signOut(): void {
    this.authState.signOut();
    this.viewStore.setView(AppView.SignIn);
  }
}
